import React from 'react'
import {observer, inject} from 'mobx-react';
import {
    CircularProgress, Container
} from "@material-ui/core";
import {BookingHistoryElement} from "./element";
import {BookingCancelConfirmDialog} from "../../cabinet/history/booking-cancel-confirm-dialog";

const styles = {
    container: {
        color: '#4a4a4a',
        display: 'flex',
        minHeight: '100vh',
        justifyContent: 'center'
    },
    loader: {
        margin: 'auto',
    },
    main: {
        width: '85vw',
        // margin: 'auto'
    },
    one_type: {
        marginBottom: '2em'
    },
    empty_list: {
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    one_type_title: {
        fontSize: '1.25em',
        fontWeight: '500',
        marginTop: '40px',
        marginBottom: '1em'
    },
    header: {
        display: 'flex',
        margin: '3em 0',
        justifyContent: 'space-between',
        counter: {
            fontSize: '1.75em',
            fontWeight: '700',
            lineHeight: '1.5em'
        },
        legend: {
            fontSize: '0.8em',
            fontWeight: '700',
            lineHeight: '1.5em'
        },
        element: {
            width: '35%',
            textAlign: 'center'
        },
    }
};

const BookingHistoryIndex = inject('bookingHistoryStore', 'authStore')(observer(({bookingHistoryStore, authStore}) => {
        bookingHistoryStore.load();
        return (
            <Container style={styles.container} className="booking-history-root">
                {bookingHistoryStore.loading ?
                    <CircularProgress color="secondary" style={styles.loader}/> :
                    <div className="booking-history" style={styles.main}>
                        {bookingHistoryStore.last.length === 0 && bookingHistoryStore.waiting.length === 0 && bookingHistoryStore.accepted.length === 0 ?
                            <div style={styles.empty_list}>
                                <div>
                                    У вас ещё не было заказов <span role="img" aria-label=":sad:">😔</span>
                                </div>
                            </div>
                            : <div style={styles.header}>
                                <div style={styles.header.element}>
                                    <div style={styles.header.counter}>{bookingHistoryStore.total_count}</div>
                                    <div style={styles.header.legend}>Всего<br/>заказов</div>
                                </div>
                                <div style={styles.header.element}>
                                    <div style={styles.header.counter}>{bookingHistoryStore.count_cur_month}</div>
                                    <div style={styles.header.legend}>Заказов в этом<br/>месяце</div>
                                </div>
                            </div>
                        }
                        {bookingHistoryStore.accepted.length > 0 ?
                            <div style={styles.one_type}>
                                <div style={styles.one_type_title}>Ваши заказы</div>
                                {bookingHistoryStore.accepted.map((el, key) => <BookingHistoryElement key={key} booking={el}
                                                                                                      cancelOrderClickCallback={bookingHistoryStore.cancelOrderClick}
                                                                                                      type='accepted'/>)}
                            </div>
                            : ''}
                        {bookingHistoryStore.waiting.length > 0 ?
                            <div style={styles.one_type}>
                                <div style={styles.one_type_title}>Ждет подтверждения студии</div>
                                {bookingHistoryStore.waiting.map((el, key) => <BookingHistoryElement key={key} booking={el}
                                                                                                     type='waiting'/>)}
                            </div>
                            : ''}
                        {bookingHistoryStore.last.length > 0 ?
                            <div style={styles.one_type}>
                                <div style={styles.one_type_title}>Прошедшие заказы</div>
                                {bookingHistoryStore.last.map((el, key) => <BookingHistoryElement key={key} booking={el}
                                                                                                  type='last'/>)}
                            </div>
                            : ''}

                        <BookingCancelConfirmDialog
                            open={bookingHistoryStore.show_cancel_dialog}
                            handleCancel={() => bookingHistoryStore.show_cancel_dialog = false}
                            handleOk={bookingHistoryStore.cancelOrderCallback}
                        />
                    </div>
                }
            </Container>

        );
    }
));

export default BookingHistoryIndex
